export default "__VITE_ASSET__3d5633c2__"